import {
  Companion_getInstance1rlvzabi952im as Companion_getInstance,
  Kind_Factory_getInstance2ge7vb99ubfwr as Kind_Factory_getInstance,
  BeanDefinitionhif1nxb54kgk as BeanDefinition,
  FactoryInstanceFactory2tq2q9e5id3pz as FactoryInstanceFactory,
  KoinDefinition2pr0kscd0vkk6 as KoinDefinition,
  binds4rk2rn2wwzpn as binds,
  module39wmcymxxg0fj as module_0,
} from './projects-core-koin-core.mjs';
import {
  emptyList1g2z5xcrvp2zy as emptyList,
  getKClass1s3j9wy1cofik as getKClass,
  Unit_instance104q5opgivhr8 as Unit_instance,
  VOID7hggqo3abtya as VOID,
  protoOf180f3jzyo7rfj as protoOf,
  initMetadataForInterface1egvbzx539z91 as initMetadataForInterface,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from './kotlin-kotlin-stdlib.mjs';
import { IFeatureFlagEvaluatorscidb4c0cp4 as IFeatureFlagEvaluator } from './Shared7Punches-infrastructure-featureflag.mjs';
import {
  IShiftDropAccessor3c2fgb3dksv1c as IShiftDropAccessor,
  IShiftTradeAccessorqhpl7uylbpey as IShiftTradeAccessor,
} from './Shared7Punches-domain-shiftpool-domain.mjs';
import { ITimeOffAccessor2x87raxwv9n68 as ITimeOffAccessor } from './Shared7Punches-data-timeoff.mjs';
import { IGetPendingAvailabilityRequestCount1l41jnqopld96 as IGetPendingAvailabilityRequestCount } from './Shared7Punches-data-availability.mjs';
import { IKnockToJoinAccessor18lz687awqgh1 as IKnockToJoinAccessor } from './Shared7Punches-data-accountactivation.mjs';
import { IOvertimeRiskAccessorulrq4mhwwk0i as IOvertimeRiskAccessor } from './Shared7Punches-data-overtimerisk.mjs';
import {
  IGetPendingTrainingReviewRequestCountpuzoadshl3tu as IGetPendingTrainingReviewRequestCount,
  IIsTrainingEnabled3aj37ldfvkupo as IIsTrainingEnabled,
  ICourseAssignmentAccessor1kq9psvks8u5i as ICourseAssignmentAccessor,
} from './Shared7Punches-business-domains-training-domain.mjs';
//region block: imports
//endregion
//region block: pre-declaration
initMetadataForInterface(IActionableRequestsAccessor, 'IActionableRequestsAccessor');
initMetadataForClass(ActionableRequestsService, 'ActionableRequestsService', VOID, VOID, [IActionableRequestsAccessor]);
initMetadataForInterface(IGetTrainingStatus, 'IGetTrainingStatus', VOID, VOID, VOID, [1]);
initMetadataForClass(GetTrainingStatus, 'GetTrainingStatus', VOID, VOID, [IGetTrainingStatus], [1]);
//endregion
function get_dashboardModule() {
  _init_properties_DashboardModule_kt__idys4u();
  return dashboardModule;
}
var dashboardModule;
function dashboardModule$lambda($this$module) {
  _init_properties_DashboardModule_kt__idys4u();
  // Inline function 'org.koin.core.module.Module.factory' call
  var tmp2 = dashboardModule$lambda$lambda;
  // Inline function 'org.koin.core.module.Module.factory' call
  // Inline function 'org.koin.core.module._factoryInstanceFactory' call
  var scopeQualifier = Companion_getInstance().s1a_1;
  // Inline function 'org.koin.core.definition._createDefinition' call
  var kind = Kind_Factory_getInstance();
  var secondaryTypes = emptyList();
  var def = new BeanDefinition(scopeQualifier, getKClass(ActionableRequestsService), null, tmp2, kind, secondaryTypes);
  var factory = new FactoryInstanceFactory(def);
  $this$module.p1c(factory);
  var tmp = new KoinDefinition($this$module, factory);
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$6 = [getKClass(IActionableRequestsAccessor)];
  binds(tmp, tmp$ret$6);
  // Inline function 'org.koin.core.module.Module.factory' call
  var tmp2_0 = dashboardModule$lambda$lambda_0;
  // Inline function 'org.koin.core.module.Module.factory' call
  // Inline function 'org.koin.core.module._factoryInstanceFactory' call
  var scopeQualifier_0 = Companion_getInstance().s1a_1;
  // Inline function 'org.koin.core.definition._createDefinition' call
  var kind_0 = Kind_Factory_getInstance();
  var secondaryTypes_0 = emptyList();
  var def_0 = new BeanDefinition(scopeQualifier_0, getKClass(IGetTrainingStatus), null, tmp2_0, kind_0, secondaryTypes_0);
  var factory_0 = new FactoryInstanceFactory(def_0);
  $this$module.p1c(factory_0);
  new KoinDefinition($this$module, factory_0);
  return Unit_instance;
}
function dashboardModule$lambda$lambda($this$factory, it) {
  _init_properties_DashboardModule_kt__idys4u();
  // Inline function 'org.koin.core.scope.Scope.get' call
  var tmp = $this$factory.q1d(getKClass(IFeatureFlagEvaluator), null, null);
  // Inline function 'org.koin.core.scope.Scope.get' call
  var tmp_0 = $this$factory.q1d(getKClass(IShiftDropAccessor), null, null);
  // Inline function 'org.koin.core.scope.Scope.get' call
  var tmp_1 = $this$factory.q1d(getKClass(IShiftTradeAccessor), null, null);
  // Inline function 'org.koin.core.scope.Scope.get' call
  var tmp_2 = $this$factory.q1d(getKClass(ITimeOffAccessor), null, null);
  // Inline function 'org.koin.core.scope.Scope.get' call
  var tmp_3 = $this$factory.q1d(getKClass(IGetPendingAvailabilityRequestCount), null, null);
  // Inline function 'org.koin.core.scope.Scope.get' call
  var tmp_4 = $this$factory.q1d(getKClass(IKnockToJoinAccessor), null, null);
  // Inline function 'org.koin.core.scope.Scope.get' call
  var tmp_5 = $this$factory.q1d(getKClass(IOvertimeRiskAccessor), null, null);
  // Inline function 'org.koin.core.scope.Scope.get' call
  var tmp$ret$7 = $this$factory.q1d(getKClass(IGetPendingTrainingReviewRequestCount), null, null);
  return new ActionableRequestsService(tmp, tmp_0, tmp_1, tmp_2, tmp_3, tmp_4, tmp_5, tmp$ret$7);
}
function dashboardModule$lambda$lambda_0($this$factory, it) {
  _init_properties_DashboardModule_kt__idys4u();
  // Inline function 'org.koin.core.scope.Scope.get' call
  var tmp = $this$factory.q1d(getKClass(IIsTrainingEnabled), null, null);
  // Inline function 'org.koin.core.scope.Scope.get' call
  var tmp$ret$1 = $this$factory.q1d(getKClass(ICourseAssignmentAccessor), null, null);
  return new GetTrainingStatus(tmp, tmp$ret$1);
}
var properties_initialized_DashboardModule_kt_v8xy1c;
function _init_properties_DashboardModule_kt__idys4u() {
  if (!properties_initialized_DashboardModule_kt_v8xy1c) {
    properties_initialized_DashboardModule_kt_v8xy1c = true;
    dashboardModule = module_0(VOID, dashboardModule$lambda);
  }
}
function IActionableRequestsAccessor() {
}
function ActionableRequestsService(featureFlagEvaluator, shiftDropAccessor, shiftTradeAccessor, timeOffAccessor, getPendingAvailabilityRequestCount, knockToJoinAccessor, overtimeRiskAccessor, getPendingTrainingReviewRequestCount) {
  this.h8c_1 = featureFlagEvaluator;
  this.i8c_1 = shiftDropAccessor;
  this.j8c_1 = shiftTradeAccessor;
  this.k8c_1 = timeOffAccessor;
  this.l8c_1 = getPendingAvailabilityRequestCount;
  this.m8c_1 = knockToJoinAccessor;
  this.n8c_1 = overtimeRiskAccessor;
  this.o8c_1 = getPendingTrainingReviewRequestCount;
}
function GetTrainingStatus(isTrainingEnabled, courseAssignmentAccessor) {
  this.p8c_1 = isTrainingEnabled;
  this.q8c_1 = courseAssignmentAccessor;
}
function IGetTrainingStatus() {
}
//region block: exports
export {
  get_dashboardModule as get_dashboardModule2kh62t08o3c3i,
  IActionableRequestsAccessor as IActionableRequestsAccessor2ltg3s04f0shv,
  IGetTrainingStatus as IGetTrainingStatus3itahdcrzro5f,
};
//endregion

